"use client";

import { useContext } from "react";
import {
	OneSatContext,
	type OneSatContextValue,
} from "@/components/providers/onesat-provider";

/**
 * Hook for interacting with the 1Sat Wallet.
 *
 * Provides popup-based connection (connect/disconnect/sign) and
 * on-demand CWI transport access for BRC-100 operations (createAction).
 */
export function useOneSatWallet(): OneSatContextValue {
	return useContext(OneSatContext);
}
